import storefrontInstance from '@/api/instances/storefront';

const BikeCustomizationApi = {
  async extractPackageId(packageIds, isToast = false) {
    if (!String(packageIds).includes('-')) {
      return packageIds;
    }

    const potentialPackages = packageIds.split('-');
    const packagesUrl = `/project-one/api/packages/${packageIds}`;

    const extractValidPackage = (packages) => {
      if (!packages?.length) {
        return null;
      }

      return packages.find((bikePackage) => potentialPackages.includes(String(bikePackage?.id)));
    };

    const {data: response} = await storefrontInstance.get(packagesUrl, {toast: isToast});
    const validPackage = extractValidPackage(response?.data?.packages);

    return validPackage?.id ?? packageIds;
  },
  async buildModuleWithUserSelections({selectionsUrl, selections, isToast = false}) {
    const {data: response} = await storefrontInstance.post(selectionsUrl, {selections: selections}, {toast: isToast});
    return response;
  },
  async fetchModule(selectionsUrl, isToast = false) {
    const {data: response} = await storefrontInstance.get(selectionsUrl, {toast: isToast});
    return response;
  },
  async fetchThemes(themeUrl) {
    const {data: response} = await storefrontInstance.get(themeUrl);
    return response;
  },
  async fetchInspirations(inspirationsUrl) {
    const {data: response} = await storefrontInstance.get(inspirationsUrl);
    return response;
  },
  async saveBikeConfig({method, data}) {
    const {data: response} = await storefrontInstance[method]('/project-one/api/configurations/', data);
    return response;
  },
  async fetchSavedSelections(buildId) {
    const response = await storefrontInstance.get(`/project-one/api/configurations/${buildId}/selections/summary/`);
    return response;
  },
  async fetchBikeConfiguration(buildId) {
    const response = await storefrontInstance.get(`/project-one/api/configurations/${buildId}/`);
    return response;
  },
};

export default BikeCustomizationApi;
